import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as FullStorySDK from '@fullstory/browser';

const FullStory = () => {
  const userId = useSelector((state) => state.user.id);
  const userEmail = useSelector((state) => state.user.email);
  const userFirstName = useSelector((state) => state.user.first_name);
  const userLastName = useSelector((state) => state.user.last_name);
  const userAuthenticated = useSelector((state) => state.login.loggedin);
  const userRole = useSelector((state) => {
    if (state.user.admin) {
      return 'Admin';
    }
    if (state.user.nurse) {
      return 'Nurse';
    }
    if (state.user.supervisor) {
      return 'Supervisor';
    }
    return 'Invalid Rol';
  });

  useEffect(() => {
    if (userAuthenticated) {
      FullStorySDK.identify(userId.toString(), {
        displayName: `${userFirstName} ${userLastName}`,
        email: userEmail,
        role: userRole,
      });
    }
  }, [userId, userFirstName, userLastName, userEmail, userRole, userAuthenticated]);

  return <></>;
};

export default memo(FullStory);
